import { IRegion } from '../types/regions';

export const MOSCOW_ID = 1;
export const MOSCOW_AREA_ID = 4593;
export const MOSCOW_AND_MOSCOW_AREA_ID = -1;

export const SPB_ID = 2;
export const LO_ID = 4588;
export const SPB_AND_LO_ID = -2;

export const MOSCOW_AND_MOSCOW_AREA_REGION = {
  id: MOSCOW_AND_MOSCOW_AREA_ID,
  name: 'Москва и область',
  parentId: MOSCOW_AREA_ID,
  mainTownId: null,
};

export const SPB_AND_LO_REGION = {
  id: SPB_AND_LO_ID,
  name: 'Санкт-Петербург и область',
  parentId: LO_ID,
  mainTownId: null,
};

/**
 * Составные регионы, которых нет в ручке каталога регионов.
 */
export const SPECIAL_REGIONS: IRegion[] = [MOSCOW_AND_MOSCOW_AREA_REGION, SPB_AND_LO_REGION];
